// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer-style__footer__2cb42400","divider":"Footer-style__divider__2cb42400","row":"Footer-style__row__2cb42400","cell":"Footer-style__cell__2cb42400","appStoreLink":"Footer-style__appStoreLink__2cb42400"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer-style.scss
// module id = ./src/components/Footer/Footer-style.scss
// module chunks = 4